import { all } from 'redux-saga/effects'
import transactionDetails from './transactionDetails'
import payment from './payment'

export default function* rootSaga() {
  yield all([transactionDetails(), payment()])
}
